exports.URL_BACKEND = "https://backend.hrtest.acesy.net";
exports.ACCESS_TOKEN_NAME = 'login_access_token';